import React from "react";
import { components, OptionProps } from "react-select";
import { Icon, MutedDarkText, TinyText } from "shared/styles";
import { getStatus } from "shared/styles/defaults";
import { StyledValue } from "../styles";

export const DefaultOption: React.FC<OptionProps<any>> = ({
  data,
  children,
  ...props
}) => {
  const { icon, iconStatus, labelComponent, isDisabled, isLabel } = data;

  const content = (
    <StyledValue>
      {labelComponent || (
        <>
          {icon && <Icon as={icon} color={getStatus(iconStatus).iconColor} />}
          {data.prefix && <MutedDarkText>{data.prefix}</MutedDarkText>}
          <span>{children}</span>
          {data.suffix && <MutedDarkText>{data.suffix}</MutedDarkText>}
        </>
      )}
    </StyledValue>
  );

  if (isDisabled)
    return (
      <div
        className={`select__option select__option--is-disabled ${
          props.isSelected && "select__option--is-selected"
        }`}
      >
        {content}
      </div>
    );

  if (isLabel)
    return (
      <div className={"select__option select__option--is-label"}>
        <TinyText>{content}</TinyText>
      </div>
    );

  return (
    <components.Option data={data} {...props}>
      {content}
    </components.Option>
  );
};
